import React, { useContext, useCallback, useEffect, useState } from "react";
import { MapContext } from "context/map";
import { CircleNotch } from "phosphor-react";
import ZoneFields from "./components/ZoneFields";
import ZonePanel from "./components/ZonePanel";
import RasterLoading from "../RasterLoading";
import "./index.scss";

const ZoneFarm = () => {
  const { state } = useContext(MapContext);
  const { map, fieldSelection, zoneLayerTransparency } = state;
  const [zoneLayerLoading, setZoneLayerLoading] = useState(false);
  const [zoneLayerBackgroundLoading, setZoneLayerBackgroundLoading] =
    useState(false);

  const drawZones = useCallback(() => {
    const zoneSource = map.getSource("zones");

    if (zoneSource) return;

    map.addSource("zones", {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: [],
      },
    });

    map.addLayer({
      id: "zones",
      type: "fill",
      source: "zones",
      paint: {
        "fill-opacity": zoneLayerTransparency,
      },
    });

    map.addLayer({
      id: "zones-outline",
      type: "line",
      source: "zones",
      layout: {
        "line-join": "round",
        "line-cap": "round",
      },
      paint: {
        "line-color": "#6E6E6E",
        "line-width": 0.6,
      },
    });
  }, [map, zoneLayerTransparency]);

  useEffect(() => {
    drawZones();
  }, [drawZones]);

  useEffect(() => {
    if (zoneLayerTransparency === undefined) return;

    const zoneLayer = map.getLayer("zones");
    if (zoneLayer) {
      map.setPaintProperty("zones", "fill-opacity", zoneLayerTransparency);
    }
  }, [map, zoneLayerTransparency]);

  const renderRasterLoading = () => {
    if (zoneLayerLoading || zoneLayerBackgroundLoading) return null;

    return <RasterLoading />;
  };

  const renderZoneLayerLoading = () => {
    if (!zoneLayerLoading) return null;

    return (
      <div className="loading">
        <CircleNotch size={64} color="#09ba51" />
        <p className="label">Loading zones</p>
      </div>
    );
  };

  const renderZoneLayerBackgroundLoading = () => {
    if (!zoneLayerBackgroundLoading) return null;

    return (
      <div className="loading">
        <CircleNotch size={64} color="#09ba51" />
        <p className="label">Loading zones</p>
        <p className="text">
          This may take a while, you may wish to grab a cup of coffee.
        </p>
      </div>
    );
  };

  if (fieldSelection) return <ZoneFields />;

  return (
    <>
      <ZonePanel
        setZoneLayerLoading={(loading) => setZoneLayerLoading(loading)}
        setZoneLayerBackgroundLoading={(loading) =>
          setZoneLayerBackgroundLoading(loading)
        }
      />
      {renderRasterLoading()}
      {renderZoneLayerLoading()}
      {renderZoneLayerBackgroundLoading()}
    </>
  );
};

export default ZoneFarm;
